import { addEventListeners, noop } from '@datadog/browser-core';
import { supportPerformanceTimingEvent, RumPerformanceEntryType } from '../../../browser/performanceObservable';
export function trackFirstHidden(configuration, viewStart) {
  var eventTarget = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : window;
  if (document.visibilityState === 'hidden') {
    return {
      timeStamp: 0,
      stop: noop
    };
  }
  if (supportPerformanceTimingEvent(RumPerformanceEntryType.VISIBILITY_STATE)) {
    var firstHiddenEntry = performance.getEntriesByType(RumPerformanceEntryType.VISIBILITY_STATE).filter(function (entry) {
      return entry.name === 'hidden';
    }).find(function (entry) {
      return entry.startTime >= viewStart.relative;
    });
    if (firstHiddenEntry) {
      return {
        timeStamp: firstHiddenEntry.startTime,
        stop: noop
      };
    }
  }
  var timeStamp = Infinity;
  var _addEventListeners = addEventListeners(configuration, eventTarget, ["pagehide" /* DOM_EVENT.PAGE_HIDE */, "visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */], function (event) {
      if (event.type === "pagehide" /* DOM_EVENT.PAGE_HIDE */ || document.visibilityState === 'hidden') {
        timeStamp = event.timeStamp;
        stop();
      }
    }, {
      capture: true
    }),
    stop = _addEventListeners.stop;
  return {
    get timeStamp() {
      return timeStamp;
    },
    stop: stop
  };
}